import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './entregaForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaSolicitacoes } from './entregaActions';
import { getLista as getListaVeiculo } from '../veiculo/veiculoActions';
import { getLista as getListaMotorista } from '../motorista/motoristaActions';
import { getLista as getListaUnidadeMedida } from '../unidadeMedida/unidadeMedidaActions';

const columns = [{
    field: 'id',
    type: 'int'
}, {
    field: 'id_solicitacao',
    type: 'int'
}, {
    field: 'nome_parceiro',
    type: 'text'
}, {
    field: 'entregador',
    type: 'text',
    formatter: row => `${row.nome_motorista} - ${row.placa_veiculo}`
}, {
    field: 'nome_racao',
    type: 'text'
}, {
    field: 'quantidade',
    type: 'decimal'
}, {
    field: 'sigla_unidade_medida',
    type: 'text'
}, {
    field: 'data_agendamento',
    type: 'date'
}, {
    field: 'datahora_inicio',
    type: 'date'
}, {
    field: 'datahora_fim',
    type: 'date'
}];

class Entrega extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'data_agendamento',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaSolicitacoes();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
		this.props.getListaUnidadeMedida();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.id}
					${item.id_solicitacao}
					${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}
					${item.nome_parceiro}
					${item.nome_motorista}
					${item.placa_veiculo}
					${item.nome_racao}
					${FormatUtils.formatarCompetenciaTela(item.quantidade, 2)}
					${item.sigla_unidade_medida}
				`.toUpperCase().includes(pesquisar)
				);
		}).map(item => ({
			...item,
			quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
		}));

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ itens: [] });
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaSolicitacoes();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Entregas'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='id'
									label='Número'
									width={10}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='id_solicitacao'
									label='Solicitação'
									width={10}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_parceiro'
									label='Parceiro'
									width={150}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='entregador'
									label='Entregador'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_racao'
									label='Ração'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='quantidade'
									label='Quantidade'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='sigla_unidade_medida'
									label='Unidade Medida'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='data_agendamento'
									label='Agendamento'
									width={10}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='datahora_inicio'
									label='Início da Entrega'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='datahora_fim'
									label='Fim da Entrega'
									width={80}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id_solicitacao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_parceiro}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>
										<div>{item.placa_veiculo}</div>
										<div style={{ fontSize: 10 }}>{item.nome_parceiro}</div>
									</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_racao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.sigla_unidade_medida}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_agendamento)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
												});
												this.props.initForm({
													...item,
													quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={!item.datahora_inicio}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
												});
												this.props.initForm({
													...item,
													quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
				datahora_solicitacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao),
				datahora_solicitacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao),
				quantidade: parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2))
			}))} name='Entregas'>
				{[
					{ componente: <ExcelColumn key={1} label='Número' value='id'/>},
					{ componente: <ExcelColumn key={2} label='Solicitação' value='id_solicitacao'/>},
					{ componente: <ExcelColumn key={3} label='Parceiro' value='nome_parceiro'/>},
					{ componente: <ExcelColumn key={4} label='Placa' value='placa_veiculo'/>},
					{ componente: <ExcelColumn key={5} label='Motorista' value='nome_motorista'/>},
					{ componente: <ExcelColumn key={6} label='Ração' value='nome_racao'/>},
					{ componente: <ExcelColumn key={7} label='Quantidade' value='capacidade' type='number'/>},
					{ componente: <ExcelColumn key={8} label='Unidade de Medida' value='sigla_unidade_medida'/>},
					{ componente: <ExcelColumn key={9} label='Agendamento' value='data_agendamento'/>},
					{ componente: <ExcelColumn key={10} label='Início da Entrega' value='datahora_inicio'/>},
					{ componente: <ExcelColumn key={11} label='Fim da Entrega' value='datahora_fim'/>},
					{ componente: <ExcelColumn key={12} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={13} label='Usuário da Alteração' value='nome_usuario_alteentrega'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.entrega.modoTela,
	aguardando: state.entrega.aguardando,
	lista: state.entrega.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaSolicitacoes,
	getListaVeiculo, getListaMotorista, getListaUnidadeMedida
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Entrega);